import { UncontrolledTooltip } from 'reactstrap';

export default class OurUncontrolledTooltip extends UncontrolledTooltip {

    constructor(props) {
        super(props);
        this.state = { errorOccured: false };
    }

    componentDidCatch(error, info) {
        this.setState({ errorOccured: true });
        super.componentDidCatch(error, info);
    }

    render() {
        const { errorOccured } = this.state;
        if (!errorOccured) {
            try {
                return super.render();
            }
            catch (e) {
                window.error(e);
                this.setState({ errorOccured: true });
            }
        }
        else {
            return <div>error!</div>;
        }
    }
}